import { render, staticRenderFns } from "./OrderMaterialList.vue?vue&type=template&id=14d87f06&scoped=true&"
import script from "./OrderMaterialList.vue?vue&type=script&lang=js&"
export * from "./OrderMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./OrderMaterialList.vue?vue&type=style&index=0&id=14d87f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d87f06",
  null
  
)

export default component.exports